import CustomCheckbox from 'react-custom-checkbox';
import check from '../../images/managers/check.svg';
import { StyledCheckboxWrapper } from './Checkbox.styled';

const Checkbox = ({ label, checked, onChange, className, wrapperClassName, borderWidth=2, borderRadius=28, borderColor="#7D97FF", size=28, fullWidthLabel, disabled, name, value }) => {
    return (
        <StyledCheckboxWrapper fullWidthLabel={fullWidthLabel} imgSize={Math.floor(size / 1.4)} disabled={disabled} className={wrapperClassName}>
            <CustomCheckbox
                className={checked ? `checked icon-wrap ${className ? className : ''}` : `icon-wrap ${className ? className : ''}`}
                icon={<img src={check} alt="check" />}
                borderColor={borderColor}
                borderRadius={borderRadius}
                borderWidth={borderWidth}
                style={{ overflow: "hidden" }}
                size={size}
                label={label}
                checked={checked}
                onChange={onChange}
                labelClassName="checkboxLabel"
                name={name}
                value={value}
            />
        </StyledCheckboxWrapper>
    );
};

export default Checkbox;